import { Stack, useNavigation } from 'expo-router';

export default function SettingsLayout() {
  const navigation = useNavigation();

  return (
    <Stack
      screenOptions={{ headerShown: false }}
      screenListeners={{
        state: (e) => {
          const routes = e.data.state.routes;
          const currentRoute = routes[routes.length - 1]?.name;
          // Show tab header (hamburger + search) only on settings index;
          // sub-screens render their own custom headers with back buttons
          navigation.setOptions({ headerShown: currentRoute === 'index' });
        },
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="contact" />
      <Stack.Screen name="enterprise-group" />
      <Stack.Screen name="teams" />
      <Stack.Screen name="team-detail" />
      <Stack.Screen name="team-create" />
      <Stack.Screen name="personalize" />
      <Stack.Screen name="about" />
      <Stack.Screen name="terms" />
      <Stack.Screen name="privacy" />
      <Stack.Screen name="plans" />
      <Stack.Screen name="ai-features" />
      <Stack.Screen name="prompt-editor" />
      <Stack.Screen name="notification-preferences" />
    </Stack>
  );
}
